import React from 'react';
import { Stethoscope, HeartPulse, HandHelping, FlaskConical } from 'lucide-react';
import { ROSTER_TRACKS } from '../constants/rosterTracks';

const ICONS = {
  doctor: Stethoscope,
  staff_nurse: HeartPulse,
  multi_skill_assistant: HandHelping,
  lab_technician: FlaskConical,
};

/** Segmented workforce switcher — each track has its own calendar. */
export default function RosterTrackTabs({ activeId, onChange, counts = {} }) {
  return (
    <div
      className="rounded-2xl border bg-white p-1.5 shadow-sm grid grid-cols-2 lg:grid-cols-4 gap-1.5"
      data-testid="roster-track-tabs"
      role="tablist"
      aria-label="Workforce roster"
    >
      {ROSTER_TRACKS.map((t) => {
        const on = activeId === t.id;
        const Icon = ICONS[t.id] || Stethoscope;
        const n = counts[t.id];
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.id)}
            className={`relative rounded-xl px-3 py-3 text-left transition ${
              on ? 'text-white shadow-md' : 'text-zinc-700 hover:bg-zinc-50'
            }`}
            style={on ? { background: t.accent } : {}}
            data-testid={`roster-track-${t.id}`}
          >
            <div className="flex items-center gap-2">
              <span
                className={`h-8 w-8 rounded-lg flex items-center justify-center ${
                  on ? 'bg-white/20' : 'bg-zinc-100'
                }`}
              >
                <Icon className="h-4 w-4" style={on ? undefined : { color: t.accent }} />
              </span>
              <div className="min-w-0">
                <p className={`text-sm font-semibold truncate ${on ? 'text-white' : 'text-zinc-900'}`}>
                  {t.shortLabel}
                </p>
                <p className={`text-[10px] truncate ${on ? 'text-white/80' : 'text-zinc-500'}`}>
                  {typeof n === 'number' ? `${n} shifts` : t.label}
                </p>
              </div>
            </div>
            {on && (
              <span
                className="absolute left-4 right-4 bottom-1 h-0.5 rounded-full bg-white/70"
                aria-hidden
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
